<template>
  <div class="t-datepicker" id="datepickerCalendar">
    <div class="t-check-in" id="t-check-in" style="padding: 2%; font-size: 14px; font-weight: 400; text-align: center;">
        <span style="color: #bbb;">Entrada</span>
    </div>
    <div class="t-check-out" id="t-check-out" style="padding: 2%; font-size: 14px; font-weight: 400; text-align: center;">
        <span style="color: #bbb;">Salida</span>
    </div>
    <input type="hidden" id="checkInOutValues"/>
  </div>
</template>




<script>
    //import moment from 'moment'
    import { calendar } from '../../_config'
    import { datesHelper } from '../../_helpers'

export default {
    name: 'AyRDatepickerJS',
    props: ['dates', 'format', 'single', 'maximoDias','idioma'],
    data() {
        return {
            datepicker : null,
            converted : null,
            limpiar : false
        }
    },
    mounted() {
        this.limpiar = this.clear;

        let input = document.getElementById('checkInOutValues');
        let tcheckIn = document.getElementById('t-check-in');
        let tcheckOut = document.getElementById('t-check-out');



        //Definición de variables de tipos de calendario.
        this.disabledDates = []; //Cerrado | 2
        this.noCheckInDates = []; // Online | 4
        this.noCheckOutDates = [];  // Completo | 3
        this.selectedDates = []; // Seleccionado | 5 (Múltiples)
        this.noCheckInOutDates = [];

        this.checkInSelected = '';
        this.checkOutSelected = '';

        //Limpieza de las fechas que vienen de BookingCalendar
        /**
         * Estados:
         * 1 - Libre
         * 2 - Cerrado
         * 3 - Completo
         * 4 - Online
         * 5 - Selección actual
         */

        let todayDate = new Date();
        let todayDay = ( todayDate.getDate() < !10 ) ? "0"+todayDate.getDate() :  todayDate.getDate()
        let todayMonth = ( (todayDate.getMonth()+1) < 10 ) ? "0"+(todayDate.getMonth()+1) : (todayDate.getMonth()+1)
        let todayYear = todayDate.getFullYear()
        
        let today = todayYear+"-"+todayMonth+"-"+todayDay

        let tomorrowDate = this.addOneDayToDate(todayDate);
        let tomorrowDay = ( tomorrowDate.getDate() < 10 ) ? "0"+tomorrowDate.getDate() : tomorrowDate.getDate()
        let tomorrowMonth = ( (tomorrowDate.getMonth() + 1 ) < 10 ) ? "0"+(tomorrowDate.getMonth()+1) :(tomorrowDate.getMonth()+1)
        let tomorrowYear = tomorrowDate.getFullYear()

        let tomorrow = tomorrowYear+"-"+tomorrowMonth+"-"+tomorrowDay


        for (const status in this.dates) {
            let dates = this.dates[status];
            for(let x = 0; x < dates.length; x++ ){
                let currentDate = Number(dates[x]); 
                let date = new Date(currentDate);
                
                let dateYear = date.getFullYear();
                let dateMonth = ( (date.getMonth()+1) < 10 ) ? "0"+(date.getMonth()+1) : (date.getMonth()+1);
                let dateDay = ( date.getDate() < 10) ? "0"+date.getDate() : date.getDate();

                let dateFormat = dateYear+"-"+dateMonth+"-"+dateDay;
                
                if ( status == 2) { //Cerradp
                    this.disabledDates.push(dateFormat);
                } else if ( status == 3) { // Completo
                    this.noCheckOutDates.push(dateFormat);
                } else if ( status == 4 ) { //Online
                    this.noCheckInDates.push(dateFormat);
                } else if ( status == 5 ) { //Selección actual
                    this.selectedDates.push(dateFormat);
                }         
            }
        }

            let datepicker = new HotelDatepicker(input, {
                                    //Datos
                                    format: 'YYYY-MM-DD',
                                    inline: false,
                                    showTopbar: false,
                                    clearButton: false,
                                    selectForward: true,
                                    minNights: 0,
                                    maxNights: this.maximoDias-1,
                                    startOfWeek: 'monday',
                                    moveBothMonths: true,
                                    startDate: tomorrow,
                                    disabledDates: this.disabledDates,
                                    noCheckInDates:  this.noCheckInDates,
                                    noCheckOutDates: this.noCheckOutDates,
                                    selectedDates: this.selectedDates,
                                    i18n: this.idioma,
                    });


                input.addEventListener('afterClose', this.execCalendar);

                tcheckIn.addEventListener('click', function(){
                    datepicker.open();
                });
                tcheckOut.addEventListener('click', function(){
                    datepicker.open();
                });

        },
        methods: { 
        addOneDayToDate ( _date ) {
            _date.setDate(_date.getDate() + 1 )
            return _date
         },
        checkin(e, dataDate){
            this.$emit('checkInChanged', datesHelper.dateToMoment(dataDate))
        },
        checkout(e, dataDate){
            this.$emit('checkOutChanged', datesHelper.dateToMoment(dataDate))
        },
        execCalendar() {
                    //Variables con el nombre de los meses
                    let monthNames = this.idioma['month-names-short'];

                    //Guardo el valor generado por el calendario (Las dos fechas seguidas de un guión)
                    let inputVal = document.getElementById('checkInOutValues').value;
                    //Las fechas obtenidas las separo para obtener la fecha de entrada y de salida.
                    let dates = inputVal.split(" - ");
                    //Las guardo en variables
                    let checkIn = dates[0];
                    let checkOut = dates[1];
                    //Las convierto a formato fecha
                    let startDate = new Date(checkIn);
                    let endDate = new Date(checkOut);
                    //Inicializo variables que se le pasarán al final del proceso para continuar la reserva
                    let checkInDate = ''
                    let checkOutDate = ''
                    //Comparo las fechas para que si "retrocede" la fecha de inicio sea la correcta para que funcione correctamente el calendario.
                    if ( startDate < endDate) {
                        //Formato de fechas normal, del 16 a 19 mayo
                        checkInDate = startDate
                        checkOutDate = endDate
                    } else {
                        //Formato de fechas reveras, del 19 a 16 de mayo
                        checkInDate = endDate
                        checkOutDate = startDate
                    }
                    //En cualquiera de los casos anteriores, almaceno las variables en sus correctas posiciones y sigo con el proceso.

                    //Construyo los textos que posteriormente se mostrarán

                    //Datos de entrada (check in)
                    let checkInDay = ( checkInDate.getDate() < 10 ) ? '0'+checkInDate.getDate() : checkInDate.getDate()
                    let checkInMonth = ( checkInDate.getMonth() < 10 ) ? '0'+checkInDate.getMonth() : checkInDate.getMonth()
                    let checkInMonthName = monthNames[checkInDate.getMonth()]
                    let checkInYear = checkInDate.getFullYear()
                    //Datos de salida (check out)
                    let checkOutDay = ( checkOutDate.getDate() < 10 ) ? '0'+checkOutDate.getDate() : checkOutDate.getDate()
                    let checkOutMonth = ( checkOutDate.getMonth() < 10 ) ? '0'+checkOutDate.getMonth() : checkOutDate.getMonth()
                    let checkOutMonthName = monthNames[checkOutDate.getMonth()]
                    let checkOutYear = checkOutDate.getFullYear()
                    //Construyo el texto para mostrarlps en pantalla
                    let checkInLabel = checkInDay+ " "+checkInMonthName+ " "+checkInYear
                    let checkOutLabel = checkOutDay+ " "+checkOutMonthName+ " "+checkOutYear
                    //Compruebo que no este vacio para que no me de undefined sino muestro tel texto anterior.
                    if ( !isNaN(checkInDay) ) document.getElementById('t-check-in').innerHTML = checkInLabel;
                    if ( !isNaN(checkOutDay) ) document.getElementById('t-check-out').innerHTML = checkOutLabel;
                    //Finalizado el proceso, continuo el proceso para que pueda continuar.
                    this.$emit('checkInChanged', datesHelper.dateToMoment(checkInDate))
                    this.$emit('checkOutChanged', datesHelper.dateToMoment(checkOutDate))
                    
                }
    }
}
            


</script>


// WEBPACK FOOTER //
// src/components/booking/AYRDatepickerJS.vue